import React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';

import { ItemType } from 'venn-ui-kit';
import { blockSelectedPeerGroupId } from 'venn-state';

import { Block } from '../../core';

interface PeerGroupProps {
  id: string;
}

export const PeerGroup = ({ id }: PeerGroupProps) => {
  const peerGroupInformation = useRecoilValue(blockSelectedPeerGroupId(id));

  if (!peerGroupInformation) {
    return null;
  }

  return (
    <Block.SubjectsItem iconType={ItemType.PeerGroup} className="far">
      <Name>{peerGroupInformation.categoryName}</Name>
    </Block.SubjectsItem>
  );
};

const Name = styled.span`
  overflow-x: clip;
  /* Prevent superscripts from being cut off */
  overflow-y: visible;
  text-overflow: ellipsis;
`;
